import React from 'react'
import './pill-button.css'

const PillButton = ({Active, Label, Action}) => {
  return (
    <div className='pill-button'>
        <button onClick={Action} className={Active}>{Label}</button>
    </div>
  )
}

export default PillButton